/**
 * Request Your Size — Sold-out variant form
 *
 * Hooks into the theme's variantChange event to show/hide a
 * "Request Your Size" button + form when the selected variant is sold out.
 */
(function () {
  'use strict';

  var SUBMIT_LABEL = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:6px;vertical-align:-2px"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> Send Request';

  // Put the form back into a state where a new size can be requested.
  // Called whenever the selected variant changes, so a customer who already
  // sent one request can send another for a different sold-out size without
  // reloading the page.
  function resetFormState(form, successMsg, errorMsg, sizeInput) {
    var wasSubmitted = successMsg && successMsg.style.display === 'flex';

    if (form) form.style.display = '';
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';

    var submitBtn = form ? form.querySelector('.request-size__submit') : null;
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = SUBMIT_LABEL;
    }

    // Once a request has gone through, let the next sold-out size prefill
    // itself again instead of keeping the previous request's typed value.
    if (wasSubmitted && sizeInput) delete sizeInput.dataset.userEdited;
  }

  function init() {
    var sections = document.querySelectorAll('.product-section');
    sections.forEach(function (section) {
      setupSection(section);
    });
  }

  function setupSection(section) {
    var wrapper = section.querySelector('[data-request-size-wrapper]');

    if (!wrapper) return;

    // init() re-runs on shopify:section:load and walks every product section,
    // not only the reloaded one. Without this guard, sections that survived
    // the reload would get a second set of listeners and submit twice.
    if (wrapper.dataset.requestSizeInit === 'true') return;
    wrapper.dataset.requestSizeInit = 'true';

    var trigger = wrapper.querySelector('[data-request-size-trigger]');
    var formContainer = wrapper.querySelector('[data-request-size-form-container]');
    var form = wrapper.querySelector('[data-request-size-form]');
    var sizeInput = wrapper.querySelector('[data-request-size-value]');
    var sizeDisplay = wrapper.querySelector('[data-request-size-display]');
    var successMsg = wrapper.querySelector('[data-request-size-success]');
    var errorMsg = wrapper.querySelector('[data-request-size-error]');

    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var paymentButtons = addToCartBtn ? addToCartBtn.closest('.payment-buttons') : null;

    // Listen for the theme's variantChange event
    section.addEventListener('variantChange', function (evt) {
      var variant = evt.detail ? evt.detail.variant : null;
      handleVariantChange(variant, wrapper, addToCartBtn, paymentButtons, sizeInput, sizeDisplay, formContainer, form, successMsg, errorMsg);
    });

    // Toggle form on button click
    if (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = formContainer.style.display !== 'none';
        formContainer.style.display = isOpen ? 'none' : 'block';
      });
    }

    // Track when user manually edits the size input
    if (sizeInput) {
      sizeInput.addEventListener('input', function () {
        sizeInput.dataset.userEdited = 'true';
      });
    }

    // Handle form submission via fetch
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('.request-size__submit');

        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';

        if (errorMsg) errorMsg.style.display = 'none';

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(function (response) {
            // A successful post 302s to /contact and fetch follows it, so a
            // 2xx here means Shopify accepted the request. Anything else
            // (422 spam challenge, 5xx) means nothing was sent — telling the
            // customer it worked would silently lose the enquiry.
            if (!response.ok) throw new Error('Contact form rejected: ' + response.status);
            form.style.display = 'none';
            successMsg.style.display = 'flex';
          })
          .catch(function () {
            // Network failure or rejection — keep the form so they can retry.
            if (errorMsg) errorMsg.style.display = 'flex';
            submitBtn.disabled = false;
            submitBtn.innerHTML = SUBMIT_LABEL;
          });
      });
    }

    // Check initial state on page load
    var variantJson = section.querySelector('[data-variant-json]');
    if (variantJson) {
      var variants = JSON.parse(variantJson.textContent);
      var currentVariant = null;

      // Try to get variant ID from URL params first
      var urlParams = new URLSearchParams(window.location.search);
      var variantParam = urlParams.get('variant');

      if (variantParam) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantParam)) {
            currentVariant = variants[i];
            break;
          }
        }
      }

      // Fallback: use selected_or_first_available_variant logic
      // If add-to-cart is disabled on load, the current variant is sold out
      if (!currentVariant) {
        // Find the first available variant (Shopify's default selection)
        var firstAvailable = null;
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].available) {
            firstAvailable = variants[j];
            break;
          }
        }
        // If no variant is available, use the first variant
        currentVariant = firstAvailable || variants[0];
      }

      if (currentVariant) {
        handleVariantChange(currentVariant, wrapper, addToCartBtn, paymentButtons, sizeInput, sizeDisplay, formContainer, form, successMsg, errorMsg);
      }
    }
  }

  function handleVariantChange(variant, wrapper, addToCartBtn, paymentButtons, sizeInput, sizeDisplay, formContainer, form, successMsg, errorMsg) {
    if (!variant || variant.available) {
      // Variant is available — hide request form, show add to cart
      wrapper.style.display = 'none';
      formContainer.style.display = 'none';
      resetFormState(form, successMsg, errorMsg, sizeInput);
    } else {
      // Variant is sold out — show request form, hide payment buttons
      wrapper.style.display = 'block';

      // Also reset here: switching between two sold-out sizes must not leave
      // the customer stuck on the "Request sent!" panel from a previous send.
      resetFormState(form, successMsg, errorMsg, sizeInput);

      // Pre-fill the size input with the sold-out variant as a suggestion
      // (user can still type a different size)
      if (sizeInput && !sizeInput.dataset.userEdited) {
        // Which option is the size is resolved in Liquid from product.options,
        // because option order differs per brand ("Size / Color" vs
        // "Color / Size") and guessing the last one prefilled the colour.
        var sizeIndex = parseInt(wrapper.getAttribute('data-size-option-index'), 10);
        var sizeValue = variant.title;
        if (variant.options && sizeIndex >= 0 && variant.options[sizeIndex]) {
          sizeValue = variant.options[sizeIndex];
        }
        sizeInput.value = sizeValue;
      }

      // Hide dynamic checkout buttons if present
      if (paymentButtons) {
        var dynamicBtns = paymentButtons.querySelectorAll('.shopify-payment-button');
        dynamicBtns.forEach(function (btn) {
          btn.style.display = 'none';
        });
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify sections are reloaded (theme editor)
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
